import React from 'react';

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

const inputBaseClass =
    'w-full rounded-lg border border-white/10 bg-transparent px-4 py-2.5 text-sm text-white outline-none transition-colors placeholder:text-white/40 hover:bg-white/10 focus:border-orange-500 disabled:cursor-not-allowed disabled:opacity-60 read-only:cursor-default';

export const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className = '', ...props }, ref) => (
    <input ref={ref} className={`${inputBaseClass} ${className}`} {...props} />
));

Input.displayName = 'Input';

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(({ className = '', ...props }, ref) => (
    <textarea ref={ref} className={`${inputBaseClass} min-h-[120px] resize-y ${className}`} {...props} />
));

Textarea.displayName = 'Textarea';
